const CONFIG = {
  "GOOGLE_API_KEY": "AIzaSyD9-fUl7480MmoyEw5afIMtWwFJ9W5pdQs",
  "SHEETS_ID": "1er3TMg7cm___eX4JD3hIZXyNGEI5ruEoKrCgktwAptY",
  "SHEET_RANGE": "Reports!A:I",
  "DRIVE_FOLDER_ID": "1rRSPrZHiqgIIVCJkuafJ-Xdd2yUzxfmQ",
  "GALLERY_FOLDER_ID": "N/A",
  "OAUTH_CLIENT_ID": "356013901259-t7u9pm82hkccdr16f0cre7eh605ut3je.apps.googleusercontent.com",
  "ADMIN_PASSWORD_HASH": "240be518fabd2724ddb6f04eeb1da5967448d7e831c08c8fa822809f74c720a9"
};
